import styled from '@emotion/styled'
import {
  IconFATimes,
  IconFAExclamationTriangle,
  IconFAHalfHourglass
} from 'mailup-web-components'

export const StyledIconClose = styled(IconFATimes)`
  color: var(--sunset-orange);
  align-self: flex-start !important;
  width: 13px;
  height: 18px;
`
export const StyledIconWarningTriangle = styled(IconFAExclamationTriangle)`
  color: var(--sun);
  align-self: flex-start !important;
  width: 16px;
  height: 18px;
  > svg {
    top: 0 !important;
  }
`

export const StyledIconHourglass = styled(IconFAHalfHourglass)`
  align-self: flex-start !important;
`
